import React from 'react'
import { toast } from 'react-toastify'
import classNames from 'classnames'
import { ReactSVG } from 'react-svg'
import BtnIcon from './BtnIcon'

interface Props {
  className?: string
  value: boolean
  handler?: (value: boolean) => Promise<void>
}

const Favorite: React.FC<Props> = ({ className, value, handler }) => {
  const [favorite, setFavorite] = React.useState(value)

  React.useEffect(() => {
    setFavorite(value)
  }, [value])

  const onClick = async () => {
    try {
      await handler?.(!favorite)
      setFavorite(!favorite)

      if (!favorite) {
        toast.success('Добавлено в избранное')
      } else {
        toast.success('Удалено из избранного')
      }
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  return (
    <BtnIcon
      className={classNames('favorite', className, { _active: favorite })}
      large
      filled
      onClick={onClick}
    >
      <ReactSVG src={'/i/svg/bookmark.svg'} wrapper={'span'}></ReactSVG>
    </BtnIcon>
  )
}

export default Favorite
